export default __webpack_public_path__ + "static/media/marker-v2.bc9d10ec.svg";